import React from 'react';

const DEFAULT_DASHBO_LOGO_URL = 'https://cdn.mcauto-images-production.sendgrid.net/a8ac5f98aef36b5c/b32a1526-2c9d-4e55-90c1-f518541c8db4/1020x142.png';

function formatShortDate(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleDateString('es-ES', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    }).replace('.', '');
}

export function ReportHeader({ title, generatedAt, branding, dateRange, hasBusinessUnits, hasAIContent }) {
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '';
        return date.toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const formattedDate = formatDate(generatedAt);

    const startFormatted = formatShortDate(dateRange?.startDate);
    const endFormatted = formatShortDate(dateRange?.endDate);
    const hasDateRange = startFormatted && endFormatted;

    const showFlags = hasBusinessUnits || hasAIContent;

    return (
        <header className="report-header">
            <div className="report-header-logo">
                <img src={branding?.logo_url || DEFAULT_DASHBO_LOGO_URL} alt="Logo" />
            </div>
            <div className="report-header-content">
                <h1 className="report-title">{title}</h1>
                {hasDateRange && (
                    <p className="report-date-range">
                        <i className="fa fa-calendar-alt"></i>
                        {startFormatted} — {endFormatted}
                    </p>
                )}
                {formattedDate && (
                    <p className="report-date">
                        Generado el {formattedDate}
                    </p>
                )}
                {showFlags && (
                    <div className="report-flags">
                        {hasBusinessUnits && (
                            <span className="report-flag">
                                <i className="fa fa-layer-group"></i>
                                Incluye líneas de seguimiento
                            </span>
                        )}
                        {hasAIContent && (
                            <span className="report-flag">
                                <i className="fa fa-robot"></i>
                                Contiene insights y recomendaciones de Dashbito
                            </span>
                        )}
                    </div>
                )}
            </div>
        </header>
    );
}
